import React from 'react';
import { withStyles, Switch } from '@material-ui/core';
import InfoIcon from '../InfoIcon/InfoIcon';

interface Props {
    disableLabel?: string;
    enableLabel?: string;
    label?: string;
    labelClasses?: string;
    info?: string;
    checked: boolean;
    onChange?: (checked: boolean) => void;
    onInfoClick?: () => void;
    disabled?: boolean;
    isHorizontal?: boolean;
}

const NormalSwitch = withStyles({
    switchBase: {
        color: 'white',
        '&$checked': {
            color: '#007BFF',
        },
        '&$checked + $track': {
            backgroundColor: '#6bb9f9',
        },
    },
    checked: {},
    track: {},
})(Switch);

class SwitchComponent extends React.Component<Props, { checked: boolean }> {

    render(): JSX.Element {
        return (
            <div className={`${!this.props.isHorizontal ? 'display-block' : ''}`}>
                <div className={`${this.props.label && this.props.info ? 'flex-container' : ''}`}>
                    {this.props.info &&
                        <button className="custom-icon-button margin-0-important" onClick={this.props.onInfoClick}>
                            <InfoIcon info={this.props.info} isSmallSize={true} />
                        </button>
                    }
                    {this.props.label && !this.props.isHorizontal &&
                        <span className={this.props.labelClasses || ''}>{this.props.label}</span>
                    }
                </div>
                <div className={`${this.props.isHorizontal ? 'display-flex width-180px align-items-center' : ''}`}>
                    {this.props.label && this.props.isHorizontal &&
                        < span className={'display-flex align-items-center'}>{this.props.label}</span>}
                    <NormalSwitch disabled={this.props.disabled} checked={this.props.checked} onChange={(event: React.ChangeEvent<HTMLInputElement>) => this.props.onChange && this.props.onChange(event.target.checked)} name="switch" />
                </div>
            </div>
        );
    }
}

export default SwitchComponent;
